import Logo from "../../assets/logos/newLogo.png";

const HeaderSection = () => {
  return (
    <header className="bg-white shadow border-b-2 ">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between max-w-7xl">
        <div className="flex items-center">
          <a href="/dashboard/">
            <img src={Logo} width={100} />
          </a>
        </div>
        <nav>
          <ul className="flex space-x-4">
            <li>
              {/* <a href="/dashboard/" className="text-gray-800 hover:text-green-500">
                Home
              </a> */}
            </li>
            {/* <li>
              <a href="/pricing" className="text-gray-800 hover:text-green-500">
                Pricing
              </a>
            </li> */}
            {/* <li>
              <a href="/ourapproach" className="text-gray-800 hover:text-green-500">
                Our Approach
              </a>
            </li> */}
            <li>
              {/* <a href="/contactus" className="text-gray-800 hover:text-green-500">
                Contact Us
              </a> */}
            </li>
          </ul>
        </nav>
        <div>
          <a href="/contactus" className="text-gray-800 hover:text-green-500">
            Contact Us
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeaderSection;
